import TextButton from 'LuxKit/Button/TextButton'
import LineMapIcon from 'LuxKit/Icons/line/LineMapIcon'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { getSVGImageUrl } from 'lib/image/imageUtils'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const StyledGroup = styled(Group)`
  background-image: url(${getSVGImageUrl('lebt-map-view-background-full')});
  background-position: center left;
  /* need to zoom in on the image */
  background-size: 150%;
  height: ${rem(80)};

  [dir='rtl'] & {
    background-position: center right;
  }

  ${mediaQueryUp.tablet} {
    height: ${rem(90)};
  }
`

interface Props {
  /** For callers whose own wrapper is a button, where a real one here would nest interactives. */
  isNonInteractable?: boolean
}

function MapViewBand({ isNonInteractable }: Props) {
  const intl = useIntl()

  return (
    <StyledGroup direction="horizontal" horizontalAlign="center" verticalAlign="center">
      <TextButton
        kind="primary"
        variant="dark"
        startIcon={<LineMapIcon />}
        nonInteractable={isNonInteractable}
      >
        {intl.formatMessage({
          id: 'HXvVOiFJntO-oshArxXc',
          defaultMessage: 'View on map',
        })}
      </TextButton>
    </StyledGroup>
  )
}

export default MapViewBand
